module.exports = __webpack_public_path__ + "static/media/DubaiW23-Medium.620c0b83.woff2";